<template>
    <div>
        <div class="form-item">
            <span class="label">*所属标签</span>
            <el-select v-model="articleInfo.article_tag_id" class="icon_type" placeholder="请选择所属标签">
                <el-option v-for="(item,index) in tagList" :key="index" :label="item.name" :value="item.id"></el-option>
            </el-select>
        </div>

        <div class="form-item">
            <span class="label">*所属分类</span>
            <el-select v-model="articleInfo.article_class_id" class="icon_type" placeholder="请选择所属分类">
                <el-option v-for="(item,index) in classList" :key="index" :label="item.name" :value="item.id"></el-option>
            </el-select>
        </div>

        <div class="form-item">
            <span class="label">*文章标题</span>
            <el-input v-model="articleInfo.title" clearable style="width: 300px" class="name-input" placeholder="请输入跳转URL" />
        </div>

        <div class="form-item">
            <span class="label">*文章封面:</span>
            <div>
                <imageUpload v-model="articleInfo.article_img" :limit="1" />
                <div class="el-upload__tip">建议尺寸为654*365</div>
            </div>
        </div>

        <div class="form-item">
            <span class="label">自定义ALT:</span>
            <el-input v-model="articleInfo.img_alt" clearable style="width: 300px" class="name-input" placeholder="请输入自定义ALT" />
        </div>

        <div class="form-item sendTime">
            <span class="label">*是否定时发送</span>
            <el-select v-model="articleInfo.is_time" class="icon_type" placeholder="请选择是否定时发送">
                <el-option label="是" value="2"></el-option>
                <el-option label="否" value="1"></el-option>
            </el-select>
        </div>

        <div v-if="articleInfo.is_time==2" class="form-item">
            <span class="label">定时发布</span>
            <el-date-picker
                v-model="articleInfo.push_time"
                type="datetime"
                value-format="yyyy-MM-dd HH:mm:ss"
                placeholder="请选择发布时间"
                style="width: 300px"
            >
            </el-date-picker>
        </div>

        <div>
            <div class="seo_set">*SEO配置</div>
            <div class="seo_wrap">
                <div class="form-item">
                    <span class="label">*页面标题：</span>
                    <el-input v-model="articleInfo.seo_t" clearable style="width: 300px" class="name-input" placeholder="请输入页面标题：" />
                </div>

                <div class="form-item">
                    <span class="label">*描述：</span>
                    <el-input v-model="articleInfo.seo_d" clearable style="width: 300px" class="name-input" placeholder="请输入描述" />
                </div>

                <div class="form-item">
                    <span class="label">*关键词：</span>
                    <el-input v-model="articleInfo.seo_k" clearable style="width: 300px" class="name-input" placeholder="请输入关键词" />
                </div>
            </div>
        </div>

        <div class="qull_wrap">
            <label class="detail-label form-title">图文详情</label>
            <vue-ueditor-wrap v-model="articleInfo.content" style="width: 800px" :config="editorConfig"  :editor-dependencies="editorDependenciesConfig"></vue-ueditor-wrap>
        </div>

        <div class="form-item">
            <el-button type="primary" :loading="loading" @click="onSaveClick">确定</el-button>
            <el-button type="primary" :loading="loading" plain @click="$router.back()">取消</el-button>
        </div>
    </div>
</template>
<script>
import { getArticleTag, getArticleClass, addArticle, editArticle, articleDetail } from '@/api/college.js';
import baseURL from '../../configs/baseUrl';
import utils from '@/jslibs/utils';
import { imgDomain } from '../../configs/env';
import imageUpload from '@/components/ImageUpload';
export default {
    components: {
        imageUpload
    },
    data() {
        return {
            icon_type: 1,
            imgDomain,
            headers: {
                'X-Access-Token': utils.getCookie('X-Access-Token') || ''
            },
            baseURL,
            loading: false,
            id: "",
            articleInfo: {
                article_img: [],
                img: ""
            },
            tagList: [],
            classList: []
        };
    },

    created() {
        this.getTagList();
        this.getClassList()
    },

    async mounted() {
        const id = this.$route.query.id;
        this.id = id;
        if (id) {
            this.getArticleDetail(id)
        }
    },

    methods: {
        async getTagList() {
            const params = { page_index: 1, page_size: 999 }
            const { total, data } = await getArticleTag(params);
            this.tagList = data;
        },

        async getClassList() {
            const params = { page_index: 1, page_size: 999 }
            const { total, data } = await getArticleClass(params);
            this.classList = data;
        },

        async getArticleDetail(id) {
            const res = await articleDetail(id);
            this.articleInfo = res;
            if (this.articleInfo.img) {
                this.articleInfo.article_img = this.articleInfo.img.split();
            }
            this.articleInfo.is_time = String(this.articleInfo.is_time);
        },

        async onSaveClick() {
            const { article_tag_id, article_class_id, title, article_img, is_time, push_time, seo_t, seo_d, seo_k, content } = this.articleInfo;
            if (!article_tag_id) return this.$notify.error({ title: '请选择所属标签' });
            if (!article_class_id) return this.$notify.error({ title: '请选择所属分类' });
            if (!title) return this.$notify.error({ title: '请输入文章标题' });
            if (!article_img.length) {
                return this.$notify.error({ title: '请上传文章封面' });
            }
            if (!is_time) return this.$notify.error({ title: '请选择是否定时发送' });
            if (is_time == 2 && !push_time) return this.$notify.error({ title: '请选择定时发送时间' });
            if (!seo_t) return this.$notify.error({ title: '请输入页面标题' });
            if (!seo_d) return this.$notify.error({ title: '请输入页面描述' });
            if (!seo_k) return this.$notify.error({ title: '请输入页面关键词' });
            this.articleInfo.img = this.articleInfo.article_img.join();
            this.confirmClick()
        },

        async confirmClick() {
            if (this.id) { // 编辑
                const res = await editArticle(this.id, this.articleInfo);
                if (res == true) {
                    this.$notify({ title: '文章编辑成功', type: 'success' });
                    this.$router.back();
                } else {
                    this.$notify.error({ title: '操作失败' });
                }
            } else {
                const res = await addArticle(this.articleInfo);
                if (res == true) {
                    this.$notify({ title: '新增文章成功', type: 'success' });
                    this.$router.back();
                } else {
                    this.$notify.error({ title: '操作失败' });
                }
            }
        }
    }
};
</script>
<style lang="less" scoped>
.form-item {
    display: flex;
    align-items: center;
    margin-bottom: 20px;
    .icon_type{
        margin-right: 20px;
    }
}
.sendTime{
    margin: 30px 0;
}
.label {
    display: inline-block;
    width: 100px;
    flex-shrink: 0;
}
.el-select{
    width: 300px;
}

.seo_wrap{
    display: flex;
    flex-wrap: wrap;
    border: 1px solid #ccc;
    margin: 20px 0;
    padding: 20px;
    .form-item {
        margin-left: 0;
        margin-right: 30px;
        .label{
            width: 80px;
        }
    }
}
.qull_wrap{
    margin: 20px 0;
    label{
        display: block;
        margin-bottom: 10px;
        font-size: 16px;
    }
}
.el-upload__tip{
    color: red;
}
</style>
